export default __webpack_public_path__ + "static/Lexend-Black-01f6ec6560c7e223a6d18c2e702d719d.woff";